<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="purchaseAirlinesObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>
            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">{{ title }} </p>
                    <p>Trigger for any instant purchase airlines / low cost carriers </p>
                </div>
                <div class="allbtns">
                    <b-switch :rounded="true" :value="purchaseAirlinesObj.isActive"
                        v-model="purchaseAirlinesObj.isActive" @input="hideInstantPurchase" :left-label="true">{{
                            purchaseAirlinesObj.isActive ? 'Active' : 'Inactive' }}
                    </b-switch>
                </div>
            </div>
        </div>
        <StandardRuleActions v-if="purchaseAirlinesObj.isActive" :ruleObj="purchaseAirlinesObj" :title="title"
            @save="updateActions" />
    </div>
</template>
<script>
import StandardRuleActions from "../StandardRuleActions.vue";

export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    components: {
        StandardRuleActions
    },
    data() {
        return {
            purchaseAirlinesObj: this.value ? this.value : {
                name: "hideInstantPurchase",
                isActive: false,
                type: 'air',
                message: 'Trigger for any instant purchase airlines / low cost carriers',
            },
            title: "Instant purchase airlines"
        }
    },
    methods: {
        hideInstantPurchase() {
            if (!this.purchaseAirlinesObj.isActive) {
                // Clear the custom action parameters when deactivating
                this.clearActionParams();
            }

            this.emitRuleObj();
        },
        clearActionParams() {
            // Reset to default actions when rule is not active ()
            this.purchaseAirlinesObj.useCustomActions = false;
            delete this.purchaseAirlinesObj.visibility;
            delete this.purchaseAirlinesObj.approvalLevel;
            delete this.purchaseAirlinesObj.notifications;
        },
        updateActions(updatedRule) {
            // Merge the updated properties into purchaseAirlinesObj
            this.purchaseAirlinesObj = { ...this.purchaseAirlinesObj, ...updatedRule };

            // If useCustomActions is false, delete the associated properties
            if (!updatedRule.useCustomActions) {
                this.clearActionParams()
            }

            this.emitRuleObj();
        },
        emitRuleObj() {
            this.$emit('hideInstantPurchase', this.purchaseAirlinesObj);
        },
    },
    mounted() {
        this.purchaseAirlinesObj.type = 'air';
        this.emitRuleObj();

    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                this.purchaseAirlinesObj = this.value;
                this.purchaseAirlinesObj.type = 'air';
                this.emitRuleObj();

            },
            deep: true,
        },
    },
}
</script>